import { Layouts } from '@/components/Layouts';
import StudioProviders from '@/pages/video-library/components/StudioProviders';
import { ProtectedRoutes } from '@/routes/ProtectedRoutes';
import { renderPublicRoutes } from '@/routes/PublicRoutes';
import { Routes as ReactRoutes, Route } from 'react-router-dom';
import './app.css';
import AppProviders from './AppProviders';

function App() {
    return (
        <AppProviders>
            <ReactRoutes>
                {renderPublicRoutes()}
                <Route
                    path="*"
                    element={
                        <StudioProviders>
                            <Layouts>
                                <ProtectedRoutes />
                            </Layouts>
                        </StudioProviders>
                    }
                />
            </ReactRoutes>
        </AppProviders>
    );
}

export default App;
